import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {BringozLoaderService} from "../../../../commons/services/bringoz-loader.service";

export class VehicleChargeNewComponent implements IController {
  program: any;
  groups: any;
  programId: any;
  accountId: any;

  public isDesktop: boolean;
  public groupKeys: any;
  public isSaveAvailable: boolean;
  public groupedVehicles: any;
  private _groupedVehiclesCopy: any;

  public isOpenRowsMap = new Map();
  public selectedGroupKey: string;
  private _selectedGroupKey: string;
  private _vehiclesRef: any;

  constructor(private PricePlanService, private $mdMedia, private $vehicles,
              private bringozLoaderService: BringozLoaderService) {
    this.isDesktop = $mdMedia('gt-md');
  }

  $onInit() {
    this.initValues();
  }

  initValues(){
    this.isSaveAvailable = false;
    this._vehiclesRef = this.$vehicles();
    this.groupKeys = this.PricePlanService.generatePreferencesDataGroupKeys(this.program.data);
    this._initVehicles();
  }

  _initVehicles() {
    this._groupVehiclesUnderSameType();
    this._initSelectedGroup();
    this._initFavoritesForGroups();
    this._groupedVehiclesCopy = angular.copy(this.groupedVehicles);
    this._selectedGroupKey = this.selectedGroupKey;
  }

  hasParentSelected(vehicles): boolean {
    return vehicles.some(v => v.parentSelected);
  }

  _initSelectedGroup() {
    _.forOwn(this.groupedVehicles, (vehicles, key) => {
      _.forOwn(vehicles, (vehicle) => {
        if(vehicle.selected) {
          this._setSelectedGroup(key);
          return
        }
      })
    })
  }

  _setSelectedGroup(groupKey) {
    this.selectedGroupKey = groupKey;
  }

  onDataChange() {
    this.isSaveAvailable = !_.isEqual(this.groupedVehicles, this._groupedVehiclesCopy);
  }

  onSaveProgram() {

    // Rebuild group keys for server API from the grouped vehicles map
    const groupKeysUpdate = _.cloneDeep(this.groupKeys);
    _.forOwn(this.groupedVehicles, (vehicles, groupKey) => {
      _.forOwn(vehicles, (vehicle) => {
        groupKeysUpdate.VehicleTypeFactor[vehicle.id] = {...vehicle};
      });
    });

    const updatedProgram = this.PricePlanService.generatePreferencesDataPayload(this.program, groupKeysUpdate);
    this.PricePlanService.saveProgramDataByGroups(this.programId, updatedProgram, this.groups, this.accountId)
      .then((updatedProgram) => {
        this.program = updatedProgram;
        this.initValues();
      })
  }

  onCancelChanges() {
    this.groupedVehicles = angular.copy(this._groupedVehiclesCopy);
    this.selectedGroupKey = this._selectedGroupKey;
    this.isSaveAvailable = false;
  }

  _groupVehiclesUnderSameType() {
    const groupedVehicles = {};

    // Group vehicles by type
    _.forOwn(this.groupKeys.VehicleTypeFactor, (vehicle, key) => {
        const vehicleClass = vehicle.vehicleClass;
        groupedVehicles[vehicleClass] = groupedVehicles[vehicleClass] ? [...groupedVehicles[vehicleClass], vehicle] : [vehicle];
    });

    this.groupedVehicles = angular.copy(groupedVehicles);
  }

  _initFavoritesForGroups() {
    _.forOwn(this.groupedVehicles, (vehicleGroup: any[], groupKey) => {
      // Look for favorite vehicle in group - if exists, do nothing
      const hasFavorite = vehicleGroup.some(v => v.isFavoriteInClass);
      if (hasFavorite) {
        return;
      }

      // Fall back - Look for parent favorite, if doesn't exist set first vehicle in list as favorite
      const parentFavorite = vehicleGroup.find(v => v.isParentFavoriteInClass);

      if (parentFavorite) {
        vehicleGroup.forEach(v => {
          v.isFavoriteInClass = (v.id === parentFavorite.id);
        });
      }
      else if (vehicleGroup.length > 0) {
        vehicleGroup[0].isFavoriteInClass = true;
      }
    });
  }

  expandRowForVehicleGroup(vehicleGroup, vehicles) {
    if(!this.isOpenRowsMap.has(vehicleGroup)) {
      this.isOpenRowsMap.set(vehicleGroup, true);
    } else {
      this.isOpenRowsMap.set(vehicleGroup, !this.isOpenRowsMap.get(vehicleGroup));
    }
  }

  markVehicleAsFavoriteInGroup(groupKey, vehicle) {
    _.map(this.groupedVehicles[groupKey], (currentVehicleInGroup, key) => {
      currentVehicleInGroup.isFavoriteInClass = currentVehicleInGroup.id === vehicle.id;
    });
    this.onDataChange();
  }

  onGroupSelectedChange(groupKey) {
    // Unselect all vehicles in other groups, searches for the favorite in the current group and mark it as selected
    _.map(this.groupedVehicles, (vehicles, key) => {
      if(groupKey === key) {
        return _.forOwn(vehicles, (vehicle) => vehicle.selected = vehicle.isFavoriteInClass)
      } else {
        return _.forOwn(vehicles, (vehicle) => vehicle.selected = false)
      }
    })
    this._setSelectedGroup(groupKey);
    this.onDataChange()
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('pricePlanVehicleChargeNew', {
    bindings: {
      program: '<',
      groups: '<',
      programId: '<',
      accountId: '<?'
    },
    template: require('./vehicle-charge-new.html').default,
    controller: VehicleChargeNewComponent
  });
